import _ from 'lodash';
import React from 'react';
import shallowCompare from '../../lib/shallowCompare';
import UniversalSearchResult from './UniversalSearchResult';
import styles from './index.sass';

class UniversalSearchResultsList extends React.Component {
  static propTypes = {
    wineSkus: React.PropTypes.object.isRequired,
    loading: React.PropTypes.bool,
    emptyText: React.PropTypes.string,
    inventoryRecordsListElementConfig: React.PropTypes.object
  };

  static defaultProps = {
    loading: false,
    emptyText: null
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  renderResults() {
    let wineSkus = this.props.wineSkus;
    wineSkus = wineSkus.filter(wineSku => {
      return !!wineSku.price_range_text;
    });
    if(!this.props.loading && !wineSkus.size) {
      if(this.props.emptyText) {
        return <span className={styles.emptyText}>{this.props.emptyText}</span>;
      }
      return;
    }
    let elems = wineSkus.toList().map(wineSku => {
      let props = {
        wineSku,
        key: wineSku.id,
        storeId: this.props.storeId,
        ...this.props.inventoryRecordsListElementConfig
      };
      return <UniversalSearchResult {...props} />;
    });
    if(this.props.loading) {
      elems = elems.push(<span key="loadingspinner" className="loading-spinner--teal" style={{display: 'block', marginTop: 60, marginBottom: 60}} />);
    }
    return elems;
  }

  render() {
    return (
      <div className={styles.list}>
        {this.renderResults()}
      </div>
    );
  }
}

export default UniversalSearchResultsList;



// WEBPACK FOOTER //
// banquet/components/UniversalSearchResultsList/index.js